module.exports = __webpack_public_path__ + "img/h-4.29b7ed23.svg";